import styles from './FlowSteps.module.css';

interface FlowStepsProps {
    label: string;
    steps: string[];
    className?: string;
}

export default function FlowSteps({ label, steps, className }: FlowStepsProps) {
    return (
        <figure className={[styles.flow, className].filter(Boolean).join(' ')}>
            <figcaption className={styles.label}>{label}</figcaption>
            <ol className={styles.steps}>
                {steps.map((step, index) => (
                    <li key={step} className={styles.step} data-final={index === steps.length - 1}>
                        <span className={styles.index} aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
                        <span>{step}</span>
                    </li>
                ))}
            </ol>
        </figure>
    );
}
